import {
  init,
  reactRouterBrowserTracingIntegration,
  replayIntegration,
} from '@sentry/react'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

if (!import.meta.env.DEV) {
  init({
    dsn: 'https://2cd33619ad8ea5f0eb31a5aaaed9f0a1@o4510472897167360.ingest.de.sentry.io/4510473346482256',
    tracePropagationTargets: [
      // /^https:\/\/api.connectedlife.st.cetuspro.com/,
      // /^https:\/\/api.cams-snmp.connectedlife.internal/,
    ],
    integrations: [
      reactRouterBrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
